import Api from './api';

class DataService {
  constructor() {
    this.cache = {
      apps: null,
      allApps: null,
      countries: null,
      adNetworks: null,
      menu: null,
      lastFetch: {
        apps: null,
        allApps: null,
        countries: null,
        adNetworks: null,
        menu: null
      }
    };
    
    
    this.CACHE_DURATION = 5 * 60 * 1000;
  }

  
  isCacheValid(key) {
    if (!this.cache[key] || !this.cache.lastFetch[key]) {
      return false;
    }
    
    const now = Date.now();
    const lastFetch = this.cache.lastFetch[key];
    return (now - lastFetch) < this.CACHE_DURATION;
  }

  
  async getMenuList() {
    if (this.isCacheValid('menu')) {
      return this.cache.menu;
    }

    try {
      const response = await Api.get('/api/menu_list');
      if (response?.data?.code === 0) {
        this.cache.menu = response.data.data;
        this.cache.lastFetch.menu = Date.now();
        return this.cache.menu;
      }
      throw new Error(response?.data?.messages || 'Lỗi lấy dữ liệu menu');
    } catch (error) {
      
      throw error;
    }
  }

  
  async getApps(params = {}) {
    const hasFilters = params && Object.keys(params).length > 0;

    
    if (!hasFilters) {
      return this.getAllApps();
    }

    try {
      const response = await Api.get('/api/app_list', { params });
      if (response?.data?.code === 0) {
        
        return response.data.data;
      }
      throw new Error(response?.data?.messages || 'Lỗi lấy dữ liệu apps');
    } catch (error) {
      
      throw error;
    }
  }

  
  async getAllApps() {
    if (this.isCacheValid('allApps')) {
      return this.cache.allApps;
    }

    try {
      const response = await Api.get('/api/app_list', { params: {} });
      if (response?.data?.code === 0) {
        this.cache.allApps = response.data.data;
        this.cache.lastFetch.allApps = Date.now();
        return this.cache.allApps;
      }
      throw new Error(response?.data?.messages || 'Lỗi lấy dữ liệu all apps');
    } catch (error) {
      console.error('Error fetching all apps:', error);
      throw error;
    }
  }

  
  async getCountries() {
    if (this.isCacheValid('countries')) {
      return this.cache.countries;
    }

    try {
      const response = await Api.get('api/filter/country');
      if (response?.data?.code === 0) {
        this.cache.countries = response.data.data;
        this.cache.lastFetch.countries = Date.now();
        return this.cache.countries;
      }
      throw new Error(response?.data?.messages || 'Lỗi lấy dữ liệu countries');
    } catch (error) {
      console.error('Error fetching countries:', error);
      throw error;
    }
  }

  
  async getAdNetworks() {
    if (this.isCacheValid('adNetworks')) {
      return this.cache.adNetworks;
    }

    try {
      const response = await Api.get('api/filter/ad_network');
      if (response?.data?.code === 0) {
        this.cache.adNetworks = response.data.data;
        this.cache.lastFetch.adNetworks = Date.now();
        return this.cache.adNetworks;
      }
      throw new Error(response?.data?.messages || 'Lỗi lấy dữ liệu ad networks');
    } catch (error) {
      console.error('Error fetching ad networks:', error);
      throw error;
    }
  }

  
  async preloadData() {
    try {
      
      const [allApps, countries, adNetworks, menu] = await Promise.allSettled([
        this.getAllApps(),
        this.getCountries(),
        this.getAdNetworks(),
        this.getMenuList()
      ]);

      return {
        apps: null,
        allApps: allApps.status === 'fulfilled' ? allApps.value : null,
        countries: countries.status === 'fulfilled' ? countries.value : null,
        adNetworks: adNetworks.status === 'fulfilled' ? adNetworks.value : null,
        menu: menu.status === 'fulfilled' ? menu.value : null
      };
    } catch (error) {
      
      throw error;
    }
  }

  
  clearCache() {
    this.cache = {
      apps: null,
      allApps: null,
      countries: null,
      adNetworks: null,
      menu: null,
      lastFetch: {
        apps: null,
        allApps: null,
        countries: null,
        adNetworks: null,
        menu: null
      }
    };
  }

  
  getCachedData(key) {
    return this.cache[key];
  }

  
  hasCachedData(key) {
    return this.cache[key] !== null;
  }
}


const dataService = new DataService();

export default dataService;
